import React, { useState } from "react";

import
{
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import
{
    faFolderOpen,
    faScrewdriverWrench,
    faLightbulb,
    faChevronRight,
    faWandMagicSparkles
}
from "@fortawesome/free-solid-svg-icons";


export default function AssetDetails(
{
    demoScenario = "TV",

    onDocuments,

    onMaintenance,

    onInsights,

    onAi
})
{

    const [view, setView] =
        useState("specification");

    const [photoVisible, setPhotoVisible] =
        useState(true);


    //--------------------------------------------------------
    // Demo Scenario
    //--------------------------------------------------------

    const isFcu =
        demoScenario === "FCU";


    //--------------------------------------------------------
    // Asset Data
    //--------------------------------------------------------

    const asset =
        isFcu
        ?
        {
            photo:
                "/demo/fcu.png",

            title:
                "Fan Coil Unit",

            subtitle:
                "Ceiling Mounted 4-Pipe Fan Coil Unit",

            manufacturer:
                "Daikin",

            model:
                "FWE06CT",

            assetCode:
                "FCU-01-042",

            location:
                "First Floor – Office Area",

            condition:
                "GOOD",

            confidence:
                "97%",

            description:
                "Ceiling mounted fan coil unit providing local heating and cooling to the office area. " +

                "The unit incorporates a heat exchanger coil, centrifugal fan and air filter, with " +

                "heating and chilled water connections serving the space. AI analysis identified the " +

                "asset as a fan coil unit with high confidence. The unit appears operational and in " +

                "generally good visual condition, with no significant external defects identified " +

                "during the latest survey."
        }
        :
        {
            photo:
                "/demo/tv.jpg",

            title:
                "Samsung QM75B Commercial Display",

            subtitle:
                '75" 4K UHD Commercial Display',

            manufacturer:
                "Samsung",

            model:
                "QM75B",

            assetCode:
                "AV-DIS-001",

            location:
                "Reception",

            condition:
                "GOOD",

            confidence:
                "98%",

            description:
                "Samsung QM75B 75-inch commercial display installed within the main reception area. " +

                "The unit provides visitor information, corporate communications and digital " +

                "wayfinding content. AI analysis has identified the asset with a high confidence " +

                "level and no significant visual defects were detected during the latest survey."
        };


    return (

        <div
            style={{
                height:
                    "100%",

                overflowY:
                    "hidden",

                padding:
                    "24px"
            }}
        >

            {/* =================================================
                PHOTOGRAPH
            ================================================= */}

            <div
                style={{
                    overflow:
                        "hidden",

                    transition:
                        "max-height .45s ease, opacity .35s ease",

                    maxHeight:
                        photoVisible
                            ? "240px"
                            : "46px"
                }}
            >

                {
                    photoVisible
                    ?
                    <div
                        style={{
                            position:
                                "relative"
                        }}
                    >

                        <img
                            src={asset.photo}
                            alt={asset.title}
                            style={{
                                width:
                                    "100%",

                                height:
                                    "230px",

                                objectFit:
                                    "cover",

                                borderRadius:
                                    "0px"
                            }}
                        />


                        <div
                            onClick={() =>
                                setPhotoVisible(false)
                            }
                            style={{
                                position:
                                    "absolute",

                                right:
                                    "14px",

                                bottom:
                                    "14px",

                                padding:
                                    "8px 16px",

                                borderRadius:
                                    "999px",

                                backdropFilter:
                                    "blur(20px)",

                                WebkitBackdropFilter:
                                    "blur(20px)",

                                background:
                                    "rgba(0,0,0,.45)",

                                border:
                                    "1px solid rgba(255,255,255,.10)",

                                color:
                                    "white",

                                fontWeight:
                                    600,

                                cursor:
                                    "pointer",

                                transition:
                                    ".2s"
                            }}
                        >

                            Hide Photograph

                        </div>

                    </div>
                    :
                    <div
                        onClick={() =>
                            setPhotoVisible(true)
                        }
                        style={{
                            height:
                                "46px",

                            borderRadius:
                                "0px",

                            display:
                                "flex",

                            alignItems:
                                "center",

                            justifyContent:
                                "center",

                            cursor:
                                "pointer",

                            background:
                                "rgba(66,191,245,.08)",

                            border:
                                "1px solid rgba(66,191,245,.24)",

                            color:
                                "#42bff5",

                            fontWeight:
                                600,

                            transition:
                                ".25s"
                        }}
                    >

                        🖼 Show Asset Photograph

                    </div>
                }

            </div>


            {/* =================================================
                ASSET HEADING
            ================================================= */}

            <div
                style={{
                    marginTop:
                        "22px",

                    color:
                        "white",

                    fontSize:
                        "24px",

                    fontWeight:
                        700
                }}
            >

                {asset.title}

            </div>


            <div
                style={{
                    marginTop:
                        "6px",

                    color:
                        "rgba(255,255,255,.65)",

                    fontSize:
                        "15px"
                }}
            >

                {asset.subtitle}

            </div>


            {/* =================================================
                STATUS
            ================================================= */}

            <div
                style={{
                    marginTop:
                        "12px",

                    display:
                        "inline-flex",

                    alignItems:
                        "center",

                    padding:
                        "6px 14px",

                    borderRadius:
                        "999px",

                    background:
                        "rgba(46,204,113,.15)",

                    border:
                        "1px solid rgba(46,204,113,.35)",

                    color:
                        "#2ecc71",

                    fontWeight:
                        700,

                    fontSize:
                        "12px"
                }}
            >

                ● Operational

            </div>


            {/* =================================================
                AI ASSET INTELLIGENCE
            ================================================= */}

            <div
                style={{
                    marginTop:
                        "18px",

                    padding:
                        "16px 18px",

                    display:
                        "flex",

                    alignItems:
                        "center",

                    justifyContent:
                        "space-between",

                    background:
                        "linear-gradient(" +
                        "135deg, " +
                        "rgba(66,191,245,.14) 0%, " +
                        "rgba(66,191,245,.04) 100%" +
                        ")",

                    border:
                        "1px solid rgba(66,191,245,.28)",

                    boxShadow:
                        "0 10px 30px rgba(0,0,0,.16)"
                }}
            >

                <div
                    style={{
                        display:
                            "flex",

                        alignItems:
                            "center"
                    }}
                >

                    <div
                        style={{
                            width:
                                "42px",

                            height:
                                "42px",

                            borderRadius:
                                "50%",

                            display:
                                "flex",

                            alignItems:
                                "center",

                            justifyContent:
                                "center",

                            background:
                                "rgba(66,191,245,.15)",

                            border:
                                "1px solid rgba(66,191,245,.30)",

                            color:
                                "#42bff5",

                            fontSize:
                                "17px",

                            flexShrink:
                                0
                        }}
                    >

                        <FontAwesomeIcon
                            icon={faWandMagicSparkles}
                        />

                    </div>


                    <div
                        style={{
                            marginLeft:
                                "14px"
                        }}
                    >

                        <div
                            style={{
                                color:
                                    "white",

                                fontSize:
                                    "15px",

                                fontWeight:
                                    600
                            }}
                        >

                            AI Asset Intelligence

                        </div>


                        <div
                            style={{
                                marginTop:
                                    "3px",

                                color:
                                    "rgba(255,255,255,.55)",

                                fontSize:
                                    "12px"
                            }}
                        >

                            Summary, maintenance guidance & Q&A

                        </div>

                    </div>

                </div>


                <div
                    onClick={onAi}
                    style={{
                        marginLeft:
                            "14px",

                        padding:
                            "9px 15px",

                        background:
                            "linear-gradient(180deg, #42bff5 0%, #159bd7 100%)",

                        color:
                            "white",

                        fontSize:
                            "12px",

                        fontWeight:
                            600,

                        cursor:
                            "pointer",

                        whiteSpace:
                            "nowrap",

                        boxShadow:
                            "0 6px 16px rgba(21,155,215,.25)"
                    }}
                >

                    Explore AI

                </div>

            </div>


            {/* =================================================
                VIEW SELECTOR
            ================================================= */}

            <div
                style={{
                    display:
                        "flex",

                    marginTop:
                        "22px",

                    background:
                        "rgba(255,255,255,.06)",

                    border:
                        "1px solid rgba(255,255,255,.12)",

                    borderRadius:
                        "0px",

                    overflow:
                        "hidden"
                }}
            >

                <div
                    onClick={() =>
                        setView("specification")
                    }
                    style={{
                        flex:
                            1,

                        height:
                            "42px",

                        display:
                            "flex",

                        alignItems:
                            "center",

                        justifyContent:
                            "center",

                        cursor:
                            "pointer",

                        background:
                            view === "specification"
                                ? "linear-gradient(180deg, #42bff5 0%, #159bd7 100%)"
                                : "transparent",

                        color:
                            "#fff",

                        fontSize:
                            "14px",

                        fontWeight:
                            500,

                        borderRight:
                            "1px solid rgba(255,255,255,.08)",

                        transition:
                            ".2s",

                        userSelect:
                            "none"
                    }}
                >

                    Specs

                </div>


                <div
                    onClick={() =>
                        setView("description")
                    }
                    style={{
                        flex:
                            1,

                        height:
                            "42px",

                        display:
                            "flex",

                        alignItems:
                            "center",

                        justifyContent:
                            "center",

                        cursor:
                            "pointer",

                        background:
                            view === "description"
                                ? "linear-gradient(180deg, #42bff5 0%, #159bd7 100%)"
                                : "transparent",

                        color:
                            "#fff",

                        fontSize:
                            "14px",

                        fontWeight:
                            500,

                        borderRight:
                            "1px solid rgba(255,255,255,.08)",

                        transition:
                            ".2s",

                        userSelect:
                            "none"
                    }}
                >

                    Description

                </div>


                <div
                    onClick={() =>
                        setView("resources")
                    }
                    style={{
                        flex:
                            1,

                        height:
                            "42px",

                        display:
                            "flex",

                        alignItems:
                            "center",

                        justifyContent:
                            "center",

                        cursor:
                            "pointer",

                        background:
                            view === "resources"
                                ? "linear-gradient(180deg, #42bff5 0%, #159bd7 100%)"
                                : "transparent",

                        color:
                            "#fff",

                        fontSize:
                            "14px",

                        fontWeight:
                            500,

                        transition:
                            ".2s",

                        userSelect:
                            "none"
                    }}
                >

                    Resources

                </div>

            </div>


            {/* =================================================
                VIEW CONTENT
            ================================================= */}

            {
                view === "specification"
                &&
                buildSpecification(asset)
            }

            {
                view === "description"
                &&
                buildDescription(asset)
            }

            {
                view === "resources"
                &&
                buildResources(
                    onDocuments,
                    onMaintenance,
                    onInsights
                )
            }

        </div>

    );

}



//=========================================================
// ACTION BUTTON
//=========================================================

function ActionButton(
{
    icon,
    title,
    count,
    onClick
})
{

    return (

        <div
            onClick={onClick}
            style={{
                height:
                    "72px",

                borderRadius:
                    "0px",

                display:
                    "flex",

                alignItems:
                    "center",

                justifyContent:
                    "space-between",

                padding:
                    "0 18px",

                cursor:
                    "pointer",

                background:
                    "linear-gradient(" +
                    "180deg, " +
                    "rgba(255,255,255,.055) 0%, " +
                    "rgba(255,255,255,.025) 100%" +
                    ")",

                border:
                    "1px solid rgba(255,255,255,.08)",

                boxShadow:
                    "0 8px 20px rgba(0,0,0,.14)",

                transition:
                    ".25s"
            }}
        >

            <div
                style={{
                    display:
                        "flex",

                    alignItems:
                        "center"
                }}
            >

                <div
                    style={{
                        width:
                            "42px",

                        height:
                            "42px",

                        borderRadius:
                            "50%",

                        display:
                            "flex",

                        alignItems:
                            "center",

                        justifyContent:
                            "center",

                        background:
                            "rgba(66,191,245,.14)",

                        border:
                            "1px solid rgba(66,191,245,.28)",

                        color:
                            "#42bff5",

                        flexShrink:
                            0
                    }}
                >

                    <FontAwesomeIcon
                        icon={icon}
                    />

                </div>


                <div
                    style={{
                        marginLeft:
                            "16px"
                    }}
                >

                    <div
                        style={{
                            color:
                                "white",

                            fontWeight:
                                600,

                            fontSize:
                                "16px"
                        }}
                    >

                        {title}

                    </div>


                    <div
                        style={{
                            marginTop:
                                "3px",

                            color:
                                "rgba(255,255,255,.55)",

                            fontSize:
                                "12px"
                        }}
                    >

                        Click to explore

                    </div>

                </div>

            </div>


            <div
                style={{
                    display:
                        "flex",

                    alignItems:
                        "center",

                    gap:
                        "12px"
                }}
            >

                <div
                    style={{
                        width:
                            "32px",

                        height:
                            "32px",

                        borderRadius:
                            "50%",

                        background:
                            "rgba(66,191,245,.14)",

                        border:
                            "1px solid rgba(66,191,245,.22)",

                        color:
                            "#42bff5",

                        display:
                            "flex",

                        alignItems:
                            "center",

                        justifyContent:
                            "center",

                        fontWeight:
                            700,

                        fontSize:
                            "13px"
                    }}
                >

                    {count}

                </div>


                <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{
                        color:
                            "rgba(255,255,255,.45)",

                        fontSize:
                            "15px"
                    }}
                />

            </div>

        </div>

    );

}



//=========================================================
// SPECIFICATION ROW
//=========================================================

function buildRow(label, value)
{

    return (

        <div style={rowStyle}>

            <div style={labelStyle}>

                {label}

            </div>

            <div style={valueStyle}>

                {value}

            </div>

        </div>

    );

}


const rowStyle =
{
    display:
        "flex",

    justifyContent:
        "space-between",

    alignItems:
        "center",

    padding:
        "14px 18px",

    borderBottom:
        "1px solid rgba(255,255,255,.06)"
};


const labelStyle =
{
    color:
        "rgba(255,255,255,.6)",

    fontSize:
        "13px"
};


const valueStyle =
{
    color:
        "white",

    fontWeight:
        600,

    fontSize:
        "14px"
};



//=========================================================
// SPECIFICATION
//=========================================================

function buildSpecification(asset)
{

    const conditionColour =
        "#2ecc71";


    return (

        <div
            style={{
                marginTop:
                    "24px",

                borderRadius:
                    "0px",

                background:
                    "linear-gradient(" +
                    "180deg, " +
                    "rgba(255,255,255,.055) 0%, " +
                    "rgba(255,255,255,.025) 100%" +
                    ")",

                border:
                    "1px solid rgba(255,255,255,.08)",

                overflow:
                    "hidden"
            }}
        >

            {buildRow(
                "Manufacturer",
                asset.manufacturer
            )}

            {buildRow(
                "Model",
                asset.model
            )}

            {buildRow(
                "Asset Code",
                asset.assetCode
            )}

            {buildRow(
                "Location",
                asset.location
            )}


            <div style={rowStyle}>

                <div style={labelStyle}>

                    Condition

                </div>


                <div
                    style={{
                        padding:
                            "5px 14px",

                        borderRadius:
                            "999px",

                        background:
                            `${conditionColour}22`,

                        border:
                            `1px solid ${conditionColour}66`,

                        color:
                            conditionColour,

                        fontWeight:
                            700,

                        fontSize:
                            "12px"
                    }}
                >

                    ● {asset.condition}

                </div>

            </div>


            {buildRow(
                "AI Confidence",
                asset.confidence
            )}

        </div>

    );

}



//=========================================================
// DESCRIPTION
//=========================================================

function buildDescription(asset)
{

    return (

        <div
            style={{
                marginTop:
                    "24px"
            }}
        >

            <div
                style={{
                    color:
                        "white",

                    fontWeight:
                        600,

                    marginBottom:
                        "10px",

                    fontSize:
                        "16px"
                }}
            >

                Description

            </div>


            <div
                style={{
                    padding:
                        "18px",

                    borderRadius:
                        "0px",

                    background:
                        "linear-gradient(" +
                        "180deg, " +
                        "rgba(255,255,255,.055) 0%, " +
                        "rgba(255,255,255,.025) 100%" +
                        ")",

                    border:
                        "1px solid rgba(255,255,255,.08)",

                    color:
                        "rgba(255,255,255,.78)",

                    fontSize:
                        "14px",

                    lineHeight:
                        "23px"
                }}
            >

                {asset.description}

            </div>

        </div>

    );

}



//=========================================================
// RESOURCES
//=========================================================

function buildResources(
    onDocuments,
    onMaintenance,
    onInsights
)
{

    return (

        <div
            style={{
                marginTop:
                    "24px",

                display:
                    "flex",

                flexDirection:
                    "column",

                gap:
                    "12px"
            }}
        >

            <ActionButton
                icon={faFolderOpen}
                title="Documents"
                count={18}
                onClick={onDocuments}
            />


            <ActionButton
                icon={faScrewdriverWrench}
                title="Maintenance"
                count={7}
                onClick={onMaintenance}
            />


            <ActionButton
                icon={faLightbulb}
                title="AI Insights"
                count={4}
                onClick={onInsights}
            />

        </div>

    );

}